export default __webpack_public_path__ + "static/media/pinterest-color-square.35e7dc10.svg";